import {createUseStyles} from 'react-jss'
import {faFileSignature} from "@fortawesome/free-solid-svg-icons";
import {CompanyReportModel} from '../../redux/companyMonitorTypes';
import CompanyReportInfoCard from './CompanyReportInfoCard';

interface Props {
  report: CompanyReportModel
}

const CompanyReportSignaturesCard = ({report}: Props) => {
  const styles = useStyles()

  return (
    <CompanyReportInfoCard title='Authorised signatures' icon={faFileSignature} sources={['CreditSafe']}>
      <p className={styles.signatures}>{report.authorisedSignatures ?? '-'}</p>
    </CompanyReportInfoCard>
  )
}
export default CompanyReportSignaturesCard

const useStyles = createUseStyles({
  signatures: {
    // The source text is poorly formatted, so it is printed verbatim.
    whiteSpace: 'pre-wrap'
  }
})
